import React from "react";
import { Routes, Route } from "react-router-dom";
import ModelsOverview from "./ModelsOverview";
import SectorModels from "./SectorModels";
import ModelPage from "./ModelPage";
import ModelSearchResults from "./ModelSearchResults";

const ModelsModule = () => {
  return (
    <Routes>
      <Route index element={<ModelsOverview />} />
      <Route path="search" element={<ModelSearchResults />} />
      <Route path="sector/:sectorId" element={<SectorModels />} />
      <Route path="model/:modelId" element={<ModelPage />} />
    </Routes>
  );
};

export default ModelsModule;


